import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'

export const StyledFormContainer = styled.div<{ paddings: string | undefined; disable: boolean }>`
  padding: ${({ paddings }) => paddings || '8px 0'};
  opacity: ${({ disable }) => (disable ? 0.4 : 1)};
  pointer-events: ${({ disable }) => (disable ? 'none' : 'auto')};
`

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledTable = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledRowLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-weight: ${sys.fontWeight.semibold};
`

export const StyledRowRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledSemiboldText = styled.span`
  font-weight: ${sys.fontWeight.semibold};
`
